import { Component } from '@angular/core';

@Component({
	selector: 'pi-unsupported-import-dialog-skeleton',
	templateUrl: './unsupported-import-dialog-skeleton.component.html',
	styleUrls: ['./unsupported-import-dialog-skeleton.component.scss']
})
export class UnsupportedImportDialogSkeletonComponent { }
